import styles from './shimmer.module.scss';

/* eslint-disable-next-line */
export interface ShimmerProps {
  style?: React.CSSProperties;
}

export function Shimmer(props: ShimmerProps) {
  return (
    <div className={styles.ShimmerWrapper} style={props?.style || {}}>
      <div className={styles.Shimmer}></div>
    </div>
  );
}

export default Shimmer;
